import {actions as A} from '../constants/actions';

const defaultState = {
  showUploadingFile: false
};

export default (state = defaultState, {type}) => {
  switch(type) {
    case A.SHOW_UPLOADING_FILE_POP_UP:
      return {...state, showUploadingFile: true};

    case A.HIDE_UPLOADING_FILE_POP_UP:
      return {...state, showUploadingFile: false};

    default:
      return state;
  }
}
